import $ from '../vendor/jquery';
import slidebars from '../vendor/slidebars';

// slidebars
$(function () {
  var controller = new slidebars();
  controller.init();


  $(controller.events).on('closing', function () {
    $('.off-canvas-trigger').removeClass('open');
    $('.page-header-compact').removeClass('open');
  });


  $('.off-canvas-trigger').on('click', function (event) {
    event.preventDefault();
    if ($('.off-canvas-trigger').hasClass('open')) {
      controller.close('off-canvas');
      $(this).removeClass('open');
      $(this).false('aria-expanded' , 'false');
      $(this).attr('aria-label' , 'Show Menu');
    } else {
      controller.open('off-canvas');
      $('.page-header-compact').addClass('open');
      $(this).addClass('open');
      $(this).attr('aria-expanded' , 'true');
      $(this).attr('aria-label' , 'Hide Menu');
    }
  });

  // Will hold previously focused element
  var focusedElementBeforeoffCanvasNav;

  // Find the offCanvasNav and its overlay
  var offCanvasNav = document.querySelector('.off-canvas-slidebar');

  var offCanvasNavToggle = document.querySelector('.off-canvas-trigger');
  offCanvasNavToggle.addEventListener('click', openoffCanvasNav);

  function openoffCanvasNav() {
    // Save current focus
    focusedElementBeforeoffCanvasNav = document.activeElement;

    // Listen for and trap the keyboard
    offCanvasNav.addEventListener('keydown', trapTabKey);

    // Sign-Up button
    var CloseBtn = offCanvasNav.querySelector('#close-menu');
    CloseBtn.addEventListener('click', closeoffCanvasNav);

    // Find all focusable children
    var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
    var focusableElements = offCanvasNav.querySelectorAll(focusableElementsString);
    // Convert NodeList to Array
    focusableElements = Array.prototype.slice.call(focusableElements);

    var firstTabStop = focusableElements[0];
    var lastTabStop = focusableElements[focusableElements.length - 1];

    // Show the offCanvasNav and overlay
    offCanvasNav.style.display = 'block';

    // Focus first child
  //  firstTabStop.focus();

    function trapTabKey(e) {
      // Check for TAB key press
      if (e.keyCode === 9) {

        // SHIFT + TAB
        if (e.shiftKey) {
          if (document.activeElement === firstTabStop) {
            e.preventDefault();
            //lastTabStop.focus();
            offCanvasNavToggle.focus();
          }

        // TAB
        } else {
          if (document.activeElement === lastTabStop) {
            e.preventDefault();
            firstTabStop.focus();
          }
        }
      }

      // ESCAPE
      if (e.keyCode === 27) {
        closeoffCanvasNav();
      }
    }
  }

  function closeoffCanvasNav() {
    // Hide the offCanvasNav and overlay
    //offCanvasNav.style.display = 'none';
    controller.close('off-canvas');
    // Set focus back to element that had it before the offCanvasNav was opened
    focusedElementBeforeoffCanvasNav.focus();
  }
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/slidebars.js